import { buildHeader, buildOverallSection, tonnesCO2Cell, tonnesCO2perYearCell } from "./shared";
import { formatResult } from "helpers/report";

export function buildSummaryReportData(user, reportData) {
	const data = [];

	buildHeader(data, user);

	data.push([]);

	buildOverallSection(data, reportData);

	data.push([]);

	buildPumpingSection(data, reportData);

	data.push([]);

	buildN2OSection(data, reportData);

	data.push([]);

	buildWaterSection(data, reportData);

	return data;
}

function buildPumpingSection(data, reportData) {
	data.push([
		{
			value: "Estimated GHG Emission Reductions from Pumping System for Proposed Project",
			fontWeight: "bold",
		},
	]);

	data.push([
		{
			value: "Pre-Project GHG Emissions",
		},
		{
			value: formatResult(reportData.pumpingReport.beforeGHG),
		},
		tonnesCO2perYearCell,
	]);

	data.push([
		{
			value: "Post-Project GHG Emissions",
		},
		{
			value: formatResult(reportData.pumpingReport.afterGHG),
		},
		tonnesCO2perYearCell,
	]);

	data.push([
		{
			value: "GHG Emissions Reductions from Pumping",
		},
		{
			value: formatResult(reportData.pumpingReport.yearlyGHGBenefits),
		},
		tonnesCO2perYearCell,
	]);

	data.push([
		{
			value: "10-year Project Benefits",
		},
		{
			value: formatResult(reportData.pumpingReport.tenYearGHGBenefits),
		},
		tonnesCO2Cell,
	]);
}

function buildN2OSection(data, reportData) {
	data.push([
		{
			value: "Estimated Annual Nitrous Oxide Emission Reductions",
			fontWeight: "bold",
		},
	]);

	data.push([
		{
			value: "Baseline N2O Emissions",
		},
		{
			value: formatResult(reportData.n2oReport.beforeN2O),
		},
		tonnesCO2Cell,
	]);

	data.push([
		{
			value: "Projected N2O Emissions",
		},
		{
			value: formatResult(reportData.n2oReport.afterN2O),
		},
		tonnesCO2Cell,
	]);

	data.push([
		{
			value: "Average Annual N2O-N Reductions",
		},
		{
			value: formatResult(reportData.n2oReport.avgYearlyN2OBenefits),
		},
		tonnesCO2Cell,
	]);

	data.push([
		{
			value: "10-Year Project Benefits",
		},
		{
			value: formatResult(reportData.n2oReport.tenYearN2OBenefits),
		},
		tonnesCO2Cell,
	]);
}

function buildWaterSection(data, reportData) {
	data.push([
		{
			value: "Estimated Annual Water Savings",
			fontWeight: "bold",
		},
	]);

	data.push([
		{
			value: "Baseline Water Use (in)",
		},
		{
			value: formatResult(reportData.waterReport.beforeWaterUse),
		},
	]);

	data.push([
		{
			value: "Projected Water Use (in)",
		},
		{
			value: formatResult(reportData.waterReport.afterWaterUse),
		},
	]);

	data.push([
		{
			value: "Water Use Savings (in)",
		},
		{
			value: formatResult(reportData.waterReport.waterSavings),
		},
	]);

	data.push([
		{
			value: "Water Savings Estimate (%)",
		},
		{
			value: formatResult(reportData.waterReport.percentSavings),
		},
	]);
}
